import axios from 'axios';
import { from } from 'rxjs';

export const bulkVoidLabelsByFulfillmentId = ({ fulfillmentIds = [], shouldReconcileShipTo = false }) => {
  const requestAndTransform = axios
    .post('/fulfillment/voidAsyncByFulfillmentId', {
      fulfillmentIds,
      shouldReconcileShipTo,
    })
    .then((response) => {
      return response.data;
    });

  return from(requestAndTransform);
};
